// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__11tHe","col":"CardReaderDesc_col__3cUoZ","label":"CardReaderDesc_label__1a2eV"};